import {
  ref,
  reactive,
  computed,
  onBeforeMount,
  watch,
  getCurrentInstance,
} from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import privilege from "@/router/routes/privilege";
import surveyModel from "@/models/survey-quiz/survey";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";

export default function useSurveyInfoNavbar() {
  //step navbar
  const modeEditor = ref(true);
  const stepActive = ref(0);
  const quizId = ref(0);

  const scrollToTop = () => {
    const rootEle = document.documentElement;
    rootEle.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const onNextStep = (data) => {
    stepActive.value = stepActive.value + 1;
  };

  const onPreviousStep = () => {
    stepActive.value = stepActive.value - 1;
  };

  const checkCreateOrEdit = () => {
    if (router.currentRoute.params.ref) {
      modeEditor.value = false;
      quizId.value = parseInt(router.currentRoute.params.ref);
    }
  };

  onBeforeMount(() => {
    if (localStorage.getItem("activeTab") !== null) {
      stepActive.value = parseInt(localStorage.getItem("activeTab"));
    } else {
      localStorage.setItem("activeTab", stepActive.value);
    }

    checkCreateOrEdit();
  });

  watch(
    stepActive,
    () => {
      localStorage.setItem("activeTab", stepActive.value);
    },
    { deep: true }
  );

  //survey info
  const { createSurveyModel, editSurveyModel } = surveyModel();

  const {
    openErrorModal,
    openDefaultErrorModal,
    openSuccessModal,
  } = useValidationModal();

  const isEditForm = ref(false);
  const surveyGroupId = ref(null);

  const vm = getCurrentInstance().proxy;

  const formData = reactive({
    surveyGroupId: 0,
    titleName: "",
    surveyName: "",
    surveyDesc: "",
    bannerImage: { file: null, url: null },
    displayImage: { file: null, url: null },
    status: false,
    validFrom: { date: null, time: null },
    validThrough: { date: null, time: null },
    isUploadImageQA: false,
    isHaspermission: false,
    permissionType: 1,
    informationData: {},
    permissionData: {},
    privilegeData: {},
    scoreData: {},
    maxScore: null,
    sectionid: "",
  });

  let formQuestion = reactive([
    // {
    //   seqSection: 0,
    //   sectionName: "test",
    //   sectionDesc: "test desc",
    //   seqQuestion: 0,
    //   questionId: null,
    //   questionName: "Question",
    //   questionDesc: "Description",
    //   image: { file: null, url: null },
    //   type: 1,
    //   format: 1,
    //   isRequired: false,
    //   isShowImage: false,
    //   dataChoice: [
    //     {
    //       seqChoice: 0,
    //       choiceId: null,
    //       choiceName: "choice",
    //       imageChoice: { file: null, url: null },
    //       other: "",
    //       nextstep_type: 0,
    //       nextstep_option: [],
    //     },
    //   ],
    // },
  ]);

  const optionQuestion = reactive({
    typeChoiceOption: [
      { label: "Single Choice", value: 1, icon: "SingleChoiceSvg" },
      { label: "Multiple Choice", value: 2, icon: "SingleChoiceSvg" },
      { label: "Text Area", value: 3, icon: "SingleChoiceSvg" },
      { label: "Date", value: 4, icon: "SingleChoiceSvg" },
      { label: "Dropdown", value: 5, icon: "SingleChoiceSvg" },
    ],
    formatChoiceOption: [
      { label: "Text", value: 1 },
      { label: "Image", value: 2 },
      { label: "Text & Image", value: 3 },
    ],
  });

  const resolveDateFormat = (dateStr) => {
    if (!dateStr) return;
    const dateSplit = dateStr.split("-");
    const date = dateSplit[0];
    const month = dateSplit[1];
    const year = dateSplit[2];

    return `${year}-${month}-${date}`;
  };

  const onSetFormQuestion = (formQuestionData) => {
    formQuestion = formQuestionData;
  };

  const onSetFormData = (formDataObj) => {
    formData.surveyGroupId = formDataObj.surveyGroupId;
    formData.surveyName = formDataObj.surveyName;
    formData.surveyDesc = formDataObj.surveyDesc;
    formData.bannerImage.file = formDataObj.bannerImage.file;
    formData.bannerImage.url = formDataObj.bannerImage.url;
    formData.displayImage.file = formDataObj.displayImage.file;
    formData.displayImage.url = formDataObj.displayImage.url;
    formData.status = formDataObj.status;
    formData.validFrom = formDataObj.validFrom;
    formData.validThrough = formDataObj.validThrough;
  };

  const onSetPermissionData = (permissionData) => {
    formData.permissionData = permissionData;
  };

  const onSetPrivilegeData = (privilegeData) => {
    formData.privilegeData = privilegeData;
  };

  const onSetScoreData = (scoreData) => {
    formData.scoreData = scoreData;
  };

  const onSetMaxScore = (maxScore) => {
    formData.maxScore = maxScore;
  };

  let isNext = false;

  const surveyAction = reactive({
    isMergeSection: false,
  });

  const EditQuestion = (isNext = false, isMergeSection = false) => {
    onSubmitForm(isNext, isMergeSection);
  };

  const onSubmitForm = (isNext, isMergeSection) => {
    isEditForm.value = false;
    surveyAction.isMergeSection = false;
    // set permission tag
    let tagAll;
    if (stepActive.value == 1) {
      let tagSurveyName = formData.permissionData.visibility.map((nameTag) => ({
        Tag_Name: nameTag,
        Tag_Type: 1,
      }));

      let tagSurveyNamePer = formData.permissionData.permission.map(
        (nameTag) => ({
          Tag_Name: nameTag,
          Tag_Type: 2,
        })
      );

      tagAll = tagSurveyName.concat(tagSurveyNamePer);
    }

    let privilegeData;

    if (stepActive.value == 2) {
      if (formData.privilegeData.permissionListSetting.length > 0) {
        privilegeData = formData.privilegeData.permissionListSetting.map(
          (o) => ({
            Survey_PrivilegeId: o.surveyPrivilegeId,
            PermissionId: o.permissionId,
            TagId: o.tagId,
            InventoryId: formData.privilegeData.selectInventory,
            PrivilegeId: o.selectPrivilege,
            Point: o.point,
          })
        );
      } else {
        privilegeData = [
          {
            InventoryId: formData.privilegeData.selectInventory,
            PrivilegeId: formData.privilegeData.selectPrivilegeData,
            Point: formData.privilegeData.point,
            Survey_PrivilegeId: formData.privilegeData.surveyPrivilegeId,
          },
        ];
      }
    }

    let questionData;
    let resultData;
    if (stepActive.value == 3) {
      //merge array
      let questionList = formData.scoreData.questionList.map((question) =>
        question.choiceList.map((choice) => ({
          QuestionId: choice.questionId,
          OptionId: choice.choiceId,
          Scores: choice.score,
        }))
      );

      questionData = [].concat(...questionList);

      resultData = formData.scoreData.result.map((result) => ({
        ResultId: result.resultId,
        Scores_min: result.minValue,
        Scores_max: result.maxValue,
        Title: result.name,
        Description: result.desc,
        Note: result.note,
        Cover_Image_Url: result.bannerImage.file,
        IsDeleteImage: result.IsDeleteImage,
        Detail_HtmlEditor_Th: result.termTh,
        Detail_HtmlEditor_En: result.termEng,
      }));
    }

    const payload = {
      Survey_GroupId: formData.surveyGroupId,
      IsPublish: true,
      Infomation: {
        Title: formData.titleName,
        Survey_Name: formData.surveyName,
        Survey_Desc: formData.surveyDesc,
        Cover_Image_Url: formData.bannerImage.file,
        Display_Image_Url: formData.displayImage.file,
        Status: formData.status == true ? 1 : 2,
        Valid_From:
          formData.validFrom.date && formData.validFrom.time
            ? `${resolveDateFormat(formData.validFrom.date)} ${
                formData.validFrom.time
              }`
            : null,
        Valid_Through:
          formData.validThrough.date && formData.validThrough.time
            ? `${resolveDateFormat(formData.validThrough.date)} ${
                formData.validThrough.time
              }`
            : null,
      },
      SetQuestion:
        formQuestion.length > 0
          ? formQuestion.map((section, index) => ({
              SectionId: section.sectionId,
              Seq: index + 1,
              Section_Name: section.sectionName || "Section Name",
              Section_Desc: section.sectionDesc,
              NextStep_Type:
                section.nextstepType == 1 || section.nextstepType == 6
                  ? section.nextstepType
                  : 4,
              Next_SectionId:
                section.nextstepType == 1 || section.nextstepType == 6
                  ? ""
                  : section.nextstepType,
              Question:
                section.question.length > 0
                  ? section.question.map((question) => ({
                      QuestionId: question.questionId,
                      Ques_Name: question.questionName || "Question",
                      Ques_Desc: question.questionDesc,
                      Input_Type: question.format,
                      Choice_Mode: question.type,
                      Ques_Image_URL: question.image.file,
                      IsDeleteImage: question.IsDeleteImage,
                      Ques_Image_Dup_URL: question.image.file
                        ? null
                        : question.image.url,
                      IsRequired: question.isRequired,
                      NextStep_Type: question.linkToType,
                      Next_SectionId: question.nextSectionId,
                      Next_QuestionId: question.nextQuestionId,
                      Option:
                        question.dataChoice.length > 0
                          ? question.dataChoice.map((choice) => ({
                              OptionId: choice.choiceId,
                              Option: choice.choiceName,
                              Option_Image_Url: choice.imageChoice.file,
                              Option_Image_Dup_URL: choice.imageChoice.file
                                ? null
                                : choice.imageChoice.url,
                              IsDeleteImage: choice.IsDeleteImage,
                              isotheranswer: choice.other,
                              NextStep_Type:
                                typeof choice.nextstep_type == "object"
                                  ? choice.nextstep_type.obj.nextstep_type
                                  : choice.nextstep_type
                                  ? choice.nextstep_type
                                  : 0,
                              Next_QuestionId:
                                typeof choice.nextstep_type == "object"
                                  ? choice.nextstep_type.obj.next_questionid
                                  : "",
                              Next_SectionId:
                                typeof choice.nextstep_type == "object"
                                  ? choice.nextstep_type.obj.next_sectionid
                                  : "",
                            }))
                          : "",
                    }))
                  : "",
            }))
          : "",
      Permission: {
        IsLimit: formData.permissionData.limitPlayer,
        Limit: formData.permissionData.numberPlayer,
        Tag: tagAll,
      },
      Privilege: {
        Privilage_Type: formData.privilegeData.rewardType,
        Criteria_Type:
          formData.privilegeData.rewardType != 0
            ? formData.privilegeData.isEqual
            : null,
        Reward: privilegeData,
      },
      Score: {
        IsResult: formData.scoreData.isSetScore,
        SetScore: questionData,
        SetResult: resultData,
      },
    };

    if (formData.surveyGroupId) {
      if (stepActive.value == 0) {
        delete payload.IsPublish;
        delete payload.Permission;
        delete payload.Privilege;
        delete payload.Score;

        editSurveyQuestion(payload, isNext).then((isSuccess) => {
          if (isNext == true) {
            return onNextStep();
          }
          if (isSuccess) isEditForm.value = true;
          surveyAction.isMergeSection = isMergeSection;
        });
      } else if (stepActive.value == 1) {
        delete payload.IsPublish;
        delete payload.SetQuestion;
        delete payload.Privilege;
        delete payload.Score;

        editPermission(payload, isNext).then((response) => {
          if (isNext == true) {
            return onNextStep();
          }

          isEditForm.value = true;
        });
      } else if (stepActive.value == 2) {
        delete payload.IsPublish;
        delete payload.SetQuestion;
        delete payload.Permission;
        delete payload.Score;

        editPrivilege(payload, isNext).then((response) => {
          if (isNext == true) {
            return onNextStep();
          }

          isEditForm.value = true;
        });
      } else if (stepActive.value == 3) {
        if (isNext == false) {
          delete payload.IsPublish;
        }
        delete payload.SetQuestion;
        delete payload.Permission;
        delete payload.Privilege;

        editScore(payload, isNext).then((response) => {
          if (isNext == true) {
            openSuccessModal("ทำรายการสำเร็จ !", null, "ตกลง", () =>
              router.push("/survey/survey-list")
            );
          }

          isEditForm.value = true;
        });
      }
    } else {
      delete payload.Survey_GroupId;
      delete payload.IsPublish;
      delete payload.Permission;
      delete payload.Privilege;
      delete payload.Score;

      createSurvey(payload, isNext).then((response) => {
        formData.surveyGroupId = response.data.resp.infomation.survey_groupid;

        if (isNext == false) {
          router
            .replace(
              `${router.currentRoute.path}?surveyGroupId=${formData.surveyGroupId}`
            )

            .catch((err) => {});
        } else {
          router
            .replace(
              `${router.currentRoute.path}?surveyGroupId=${formData.surveyGroupId}`
            )

            .catch((err) => {});
          onNextStep();
        }

        isEditForm.value = true;
        surveyGroupId.value = formData.surveyGroupId;
      });
    }
  };

  const createSurvey = (payload) => {
    return new Promise((resolve, reject) => {
      window.$loading(true);
      createSurveyModel.payload = payload;

      store
        .dispatch("api/apiFormRequest", createSurveyModel)
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          openDefaultErrorModal(err);
          reject(err);
        })
        .finally(() => {
          window.$loading(false);
        });
    });
  };

  const editSurveyQuestion = (payload, isNext) => {
    const setQuestion = payload.SetQuestion;
    let count = 0;
    return new Promise((resolve, reject) => {
      setQuestion.map((section, idx) => {
        window.$loading(true);
        let payloadObj = {
          Survey_GroupId: payload.Survey_GroupId,
          Infomation: payload.Infomation,
          SetQuestion: [{ ...section }],
        };

        editSurveyModel.payload = payloadObj;

        store
          .dispatch("api/apiFormRequest", editSurveyModel)
          .then((response) => {
            count++;
            if (count == setQuestion.length) resolve(true);
          })
          .catch((err) => {
            openDefaultErrorModal(err);
            reject(err);
          })
          .finally(() => {
            // window.$loading(false);
          });
      });
    });
  };

  const editPermission = (payload, isNext) => {
    return new Promise((resolve, reject) => {
      window.$loading(true);
      editSurveyModel.payload = payload;

      store
        .dispatch("api/apiFormRequest", editSurveyModel)
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          openDefaultErrorModal(err);
          reject(err);
        })
        .finally(() => {
          window.$loading(false);
        });
    });
  };

  const editPrivilege = (payload, isNext) => {
    return new Promise((resolve, reject) => {
      window.$loading(true);
      editSurveyModel.payload = payload;

      store
        .dispatch("api/apiFormRequest", editSurveyModel)
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
          openDefaultErrorModal(err);
        })
        .finally(() => {
          window.$loading(false);
        });
    });
  };

  const editScore = (payload, isNext) => {
    return new Promise((resolve, reject) => {
      window.$loading(true);
      editSurveyModel.payload = payload;
      store
        .dispatch("api/apiFormRequest", editSurveyModel)
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          openDefaultErrorModal(err);
          reject(err);
        })
        .finally(() => {
          window.$loading(false);
        });
    });
  };

  const onBack = () => {
    if (stepActive.value == 0) {
      router.push("/survey/survey-list").catch(() => {});
    } else if (stepActive.value == 1) {
      onPreviousStep();
    } else if (stepActive.value == 2) {
      onPreviousStep();
    } else if (stepActive.value == 3) {
      onPreviousStep();
    }
  };

  const validFormDisable = computed(() => {
    return (
      !formData.surveyName ||
      !formData.bannerImage.url ||
      !formData.displayImage.url ||
      !formData.validFrom.date ||
      !formData.validFrom.time ||
      !formData.validThrough.date ||
      !formData.validThrough.time
    );
  });

  const validFormDisablePublish = computed(() => {
    let isTitleNotNull = false;

    if (formData.scoreData.result) {
      formData.scoreData.result.map(() => {
        isTitleNotNull = formData.scoreData.result.every(
          (o) => o.name && o.name.trim() !== ""
        );
      });
    }

    if (formData.scoreData.isSetScore == true) {
      return (
        !formData.surveyName ||
        !formData.bannerImage.url ||
        !formData.displayImage.url ||
        !formData.validFrom.date ||
        !formData.validFrom.time ||
        !formData.validThrough.date ||
        !formData.validThrough.time ||
        formData.maxScore != formData.scoreData.totalScore ||
        !isTitleNotNull
      );
    }
  });

  const resolveDateNow = (dateInput) => {
    const date = new Date(dateInput);

    try {
      const dateStr = `${date.toLocaleString("default", {
        day: "2-digit",
      })}-${date.toLocaleString("default", {
        month: "2-digit",
      })}-${date.getFullYear()}`;

      return dateStr;
    } catch (err) {
      return "";
    }
  };

  const resolveTimeNow = (timeInput) => {
    const time = new Date(timeInput);

    try {
      const hours = time.getHours();
      const minutes = time.getMinutes();
      const seconds = time.getSeconds();

      const timeStr = `${hours < 10 ? `0${hours}` : hours}:${
        minutes < 10 ? `0${minutes}` : minutes
      }:${seconds < 10 ? `0${seconds}` : seconds}`;

      return timeStr;
    } catch (err) {
      return "";
    }
  };

  var surveyCreateTime = new Date().toJSON();

  const onSetTitleName = (title) => {
    formData.titleName = title;
  };

  onBeforeMount(() => {
    if (router.currentRoute.query.surveyGroupId) {
      formData.surveyGroupId = parseInt(
        router.currentRoute.query.surveyGroupId
      );
    } else {
      formData.surveyGroupId = parseInt(router.currentRoute.params.ref);
    }

    formData.titleName =
      "Survey" +
      " " +
      resolveDateNow(surveyCreateTime) +
      " " +
      resolveTimeNow(surveyCreateTime);
  });

  return {
    modeEditor,
    stepActive,
    quizId,
    scrollToTop,
    onNextStep,
    onPreviousStep,
    formData,
    formQuestion,
    optionQuestion,
    onSetPermissionData,
    onSetPrivilegeData,
    onSetScoreData,
    onSetFormQuestion,
    onSetFormData,
    onSubmitForm,
    isNext,
    onSetTitleName,
    editSurveyQuestion,
    onBack,
    isEditForm,
    surveyGroupId,
    validFormDisable,
    validFormDisablePublish,
    onSetMaxScore,
    EditQuestion,
    surveyAction,
  };
}
